'use client';

import { c as _c } from "react/compiler-runtime";
import { SvgArrowDownLine } from '@common/__generated__/icon';
import { useToast } from '@common/hooks';
import { cn } from '@core/utils';
import type { DownloadableCouponResponse } from '@generated/auth/types.gen';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { AuthApi } from '@/api';
interface CouponDialogContentProps {
  productId: string;
}
export const CouponDialogContent = t0 => {
  const $ = _c(39);
  const {
    productId
  } = t0;
  const {
    toast
  } = useToast();
  const queryClient = useQueryClient();
  let t1;
  if ($[0] !== productId) {
    t1 = {
      queryKey: ["downloadable-coupons", productId],
      queryFn: () => AuthApi["get:/wello/v2/auth/local-market/coupons/downloadable"]({
        query: {
          productId
        }
      })
    };
    $[0] = productId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    data,
    isPending: isLoadingCoupons
  } = useQuery(t1);
  const coupons = data?.data?.context ?? [];
  let t2;
  if ($[2] !== productId || $[3] !== queryClient || $[4] !== toast) {
    t2 = async () => {
      await queryClient.invalidateQueries({
        queryKey: ["downloadable-coupons", productId]
      });
      toast({
        message: "\uCFE0\uD3F0\uC774 \uB2E4\uC6B4\uB85C\uB4DC\uB418\uC5C8\uC5B4\uC694."
      });
    };
    $[2] = productId;
    $[3] = queryClient;
    $[4] = toast;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== toast) {
    t3 = error => {
      const message = error instanceof Error ? error.message : "\uCFE0\uD3F0 \uB2E4\uC6B4\uB85C\uB4DC\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694.";
      toast({
        message,
        type: "fail"
      });
    };
    $[6] = toast;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = {
      mutationFn: _temp,
      onSuccess: t2,
      onError: t3
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const {
    mutate: downloadCoupon,
    isPending: isDownloading
  } = useMutation(t4);
  let t5;
  if ($[11] !== productId || $[12] !== queryClient || $[13] !== toast) {
    t5 = async () => {
      await queryClient.invalidateQueries({
        queryKey: ["downloadable-coupons", productId]
      });
      toast({
        message: "\uCFE0\uD3F0\uC744 \uBAA8\uB450 \uB2E4\uC6B4\uB85C\uB4DC\uD588\uC5B4\uC694."
      });
    };
    $[11] = productId;
    $[12] = queryClient;
    $[13] = toast;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] !== toast) {
    t6 = error_0 => {
      const message_0 = error_0 instanceof Error ? error_0.message : "\uCFE0\uD3F0 \uC77C\uAD04 \uB2E4\uC6B4\uB85C\uB4DC\uC5D0 \uC2E4\uD328\uD588\uC5B4\uC694.";
      toast({
        message: message_0,
        type: "fail"
      });
    };
    $[15] = toast;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t5 || $[18] !== t6) {
    t7 = {
      mutationFn: _temp2,
      onSuccess: t5,
      onError: t6
    };
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const {
    mutate: downloadAll,
    isPending: isDownloadingAll
  } = useMutation(t7);
  const getDiscountLabel = _temp3;
  const getDaysLeft = _temp4;
  const notDownloadedIds = coupons.filter(_temp5).map(_temp6);
  const allReceived = notDownloadedIds.length === 0;
  let t8;
  if ($[20] !== coupons || $[21] !== downloadCoupon || $[22] !== getDaysLeft || $[23] !== getDiscountLabel || $[24] !== isDownloading || $[25] !== isLoadingCoupons) {
    t8 = isLoadingCoupons ? <div className="flex items-center justify-center py-40"><p className="font-400 text-Gray-550 typo-body3">불러오는 중...</p></div> : coupons.length === 0 ? <div className="flex items-center justify-center py-40"><p className="font-400 text-Gray-550 typo-body3">사용 가능한 쿠폰이 없어요</p></div> : <div className="flex flex-col gap-12">{coupons.map((coupon_0, index) => {
        const daysLeft = getDaysLeft(coupon_0.issueEndAt);
        const isReceived = !!coupon_0.downloadedYN;
        return <div key={coupon_0.couponId ?? index} className={cn("w-full rounded-xsmall py-20 pl-28 pr-20", isReceived ? "bg-Gray-200" : "bg-Gray-100")}><div className="flex w-full items-center gap-4"><div className="flex flex-1 flex-col gap-4"><div className="flex items-center gap-4"><span className={cn("font-700 typo-h5 mobile-tablet:typo-body2", isReceived ? "text-Gray-400" : "text-Gray-900")}>{getDiscountLabel(coupon_0)}</span>{!isReceived && daysLeft !== null && daysLeft > 0 && <span className="rounded-xsmall bg-O-400 px-6 py-2 font-600 text-Gray-white typo-caption2">{daysLeft}일 남음</span>}</div><span className={cn("font-400 typo-body3 mobile-tablet:typo-body4", isReceived ? "text-Gray-400" : "text-Gray-600")}>{coupon_0.couponTitle}</span></div><button type="button" className="rounded-pill p-8" disabled={isReceived || isDownloading} onClick={() => {
              if (coupon_0.couponId) {
                downloadCoupon(coupon_0.couponId);
              }
            }}><SvgArrowDownLine className={cn("size-20", isReceived ? "text-Gray-400" : "text-Gray-900")} /></button></div></div>;
      })}</div>;
    $[20] = coupons;
    $[21] = downloadCoupon;
    $[22] = getDaysLeft;
    $[23] = getDiscountLabel;
    $[24] = isDownloading;
    $[25] = isLoadingCoupons;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  const t9 = allReceived ? "bg-Gray-300 text-Gray-550" : "bg-O-400 text-Gray-white";
  let t10;
  if ($[27] !== t9) {
    t10 = cn("flex h-56 w-full items-center justify-center font-700 typo-body3", t9);
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  const t11 = allReceived || isDownloadingAll;
  let t12;
  if ($[29] !== downloadAll || $[30] !== notDownloadedIds) {
    t12 = () => downloadAll(notDownloadedIds);
    $[29] = downloadAll;
    $[30] = notDownloadedIds;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== t10 || $[33] !== t11 || $[34] !== t12) {
    t13 = <button type="button" className={t10} disabled={t11} onClick={t12}>쿠폰 모두 받기</button>;
    $[32] = t10;
    $[33] = t11;
    $[34] = t12;
    $[35] = t13;
  } else {
    t13 = $[35];
  }
  let t14;
  if ($[36] !== t13 || $[37] !== t8) {
    t14 = <div className="flex flex-col gap-32">{t8}{t13}</div>;
    $[36] = t13;
    $[37] = t8;
    $[38] = t14;
  } else {
    t14 = $[38];
  }
  return t14;
};
function _temp(couponId) {
  return AuthApi["post:/wello/v2/auth/local-market/coupons/{couponId}/download"]({
    path: {
      couponId
    }
  });
}
function _temp2(couponIds) {
  return AuthApi["post:/wello/v2/auth/local-market/coupons/download-all"]({
    body: {
      couponIds
    }
  });
}
function _temp3(coupon) {
  if (coupon.couponType === "COUPON_TYPE_FREE_SHIPPING") {
    return "\uBC30\uC1A1\uBE44 \uBB34\uB8CC";
  }
  if (coupon.discountType === "DISCOUNT_TYPE_FIXED") {
    return `${coupon.discountValue?.toLocaleString()}원`;
  }
  if (coupon.discountType === "DISCOUNT_TYPE_PERCENTAGE") {
    return `${coupon.discountValue}%`;
  }
  return "";
}
function _temp4(issueEndAt) {
  if (!issueEndAt) {
    return null;
  }
  const end = new Date(issueEndAt);
  const now = new Date();
  const diff = end.getTime() - now.getTime();
  const days = Math.ceil(diff / 86400000);
  return days > 0 ? days : 0;
}
function _temp5(c) {
  return !c.downloadedYN && c.couponId;
}
function _temp6(c_0) {
  return c_0.couponId as string;
}